import { createBrowserClient } from '@supabase/ssr'
import { getPublicSupabaseConfig } from '@/lib/config/env'
// import type { Database } from './database.types'

export function createClient() {
  const { url, anonKey } = getPublicSupabaseConfig()
  return createBrowserClient(url, anonKey)
}
